import { useFont } from '@octane/spark'
import { NAVBAR_HEIGHT_PX } from 'assets/styles/layout'
import styled from 'styled-components'

// Position the pill 12px below the navbar bottom edge so it never overlaps
// navigation controls.  NAVBAR_HEIGHT_PX is the single source of truth —
// updating it in assets/styles/layout.ts keeps both Navbar and this pill in sync.
const PILL_TOP_OFFSET_PX = NAVBAR_HEIGHT_PX + 12

export const SelectorWrapper = styled.div`
    position: fixed;
    top: ${PILL_TOP_OFFSET_PX}px;
    right: 16px;
    z-index: 9999;
`

export const SelectorPill = styled.button<{ $active: boolean }>`
    background: ${({ $active, theme }) =>
        $active
            ? theme.colors.brand.primary
            : theme.colors.monochrome.jetlineBlack};
    color: ${({ theme }) => theme.colors.monochrome.white};
    border: none;
    border-radius: 16px;
    padding: 6px 14px;
    ${() => useFont('c12', { weight: '600' })};
    cursor: pointer;
    white-space: nowrap;
    letter-spacing: 0.3px;
    box-shadow: ${({ theme }) => theme.elevations.tile};
    &:hover {
        opacity: 0.9;
    }
`

export const SelectorDropdown = styled.ul`
    position: absolute;
    right: 0;
    top: calc(100% + 6px);
    background: ${({ theme }) => theme.colors.monochrome.white};
    border: 1px solid ${({ theme }) => theme.colors.monochrome.concrete};
    border-radius: 8px;
    box-shadow: ${({ theme }) => theme.elevations.large};
    min-width: 260px;
    max-height: 320px;
    overflow-y: auto;
    padding: 4px 0;
    list-style: none;
    margin: 0;
`

export const SearchWrapper = styled.li`
    position: sticky;
    top: 0;
    z-index: 1;
    background: ${({ theme }) => theme.colors.monochrome.white};
    padding: 8px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.monochrome.concrete};
    list-style: none;
`

export const SearchInput = styled.input`
    width: 100%;
    box-sizing: border-box;
    border: 1px solid ${({ theme }) => theme.colors.monochrome.concrete};
    border-radius: 4px;
    padding: 6px 10px;
    ${() => useFont('c12', { weight: '400' })};
    outline: none;
    &:focus-visible {
        outline: auto;
    }
    background: ${({ theme }) => theme.colors.monochrome.white};
    &::placeholder {
        color: ${({ theme }) => theme.colors.monochrome.concrete};
    }
`

export const DropdownItem = styled.li<{ $selected: boolean }>`
    padding: 10px 16px;
    ${() => useFont('c14', { weight: '400' })};
    cursor: pointer;
    background: ${({ $selected, theme }) =>
        $selected ? theme.colors.monochrome.smoke : 'transparent'};
    font-weight: ${({ $selected }) => ($selected ? 600 : 400)};
    &:hover {
        background: ${({ theme }) => theme.colors.monochrome.moonGrey};
    }
`
